import { render, staticRenderFns } from "./MundoBancanteHeader.vue?vue&type=template&id=89839496&scoped=true&"
import script from "./MundoBancanteHeader.vue?vue&type=script&lang=ts&"
export * from "./MundoBancanteHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MundoBancanteHeader.vue?vue&type=style&index=0&id=89839496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89839496",
  null
  
)

export default component.exports